export const IconLockBlock: {
  name: 'icon_lock_block-41ce91a9e5f7'
} = {
  name: 'icon_lock_block-41ce91a9e5f7'
}
